import { useTrans } from "@/translations";

import { useState } from "react";

import type { Terminal } from "server/dwhApi/terminals/types.js";

import type { SavedBuildingView } from "../types";
import { BuildingListWithSearch } from "./BuildingListWithSearch";
import { BuildingTypeSelector } from "./BuildingTypeSelector";
import { PopupFooter } from "./PopupFooter";
import { SavedViewElement } from "./SavedViewElement";

type Props = {
  allViews: SavedBuildingView[];
  currentViewId?: string;
  applyView: (view: SavedBuildingView | null) => void;
  terminals: Terminal[];
  buildingTypesSelected: string[] | null;
  setBuildingTypesSelected: (value: string[] | null) => void;
  onChange: (terminalIds: string[] | null) => void;
  selectedBuildingIds: string[] | null;
};

export const BuildingSelectorPopupView: React.FC<Props> = ({
  allViews,
  currentViewId,
  applyView,
  terminals,
  buildingTypesSelected,
  setBuildingTypesSelected,
  onChange,
  selectedBuildingIds,
}) => {
  const { t } = useTrans();
  const [editingViewId, setEditingViewId] = useState<string | null>(null);

  return (
    <>
      <div className="text-grey6 px-[14px] pt-[12px] pb-[6px] text-[10.5px] font-bold tracking-wider uppercase">
        {t("portfolioPage:buildingSelectionSavedViews")}
      </div>
      <div className="flex flex-col gap-[1px] px-2 pb-2">
        {allViews.map((view) => (
          <SavedViewElement
            key={view.id}
            view={view}
            editingViewId={editingViewId}
            setEditingViewId={setEditingViewId}
            currentViewId={currentViewId}
            applyView={applyView}
          />
        ))}
      </div>

      <BuildingTypeSelector
        terminals={terminals}
        buildingTypesSelected={buildingTypesSelected}
        setBuildingTypesSelected={setBuildingTypesSelected}
        onChange={onChange}
      />

      <BuildingListWithSearch
        terminals={terminals}
        setBuildingTypesSelected={setBuildingTypesSelected}
        onChange={onChange}
        selectedBuildingIds={selectedBuildingIds}
      />

      <PopupFooter
        selectedBuildingIds={selectedBuildingIds}
        terminals={terminals}
        applyView={applyView}
        allViews={allViews}
        currentViewId={currentViewId}
      />
    </>
  );
};
